const PropTypes = require('prop-types');
const React = require('react');
const formatAmount = require('../shared/format_amount.js');

class PriceWithChange extends React.Component {
  get price() {
    let price;

    if (!this.props.discountedPrice) {
      price = this.props.price;
    } else {
      price = this.props.discountedPrice;
    }

    return formatAmount(price);
  }

  get hasDiscount() {
    return this.props.discountedPrice &&
      this.props.discountedPrice.amount !== this.props.price.amount;
  }

  get originalPrice() {
    if (this.hasDiscount) {
      return <span><strike>{formatAmount(this.props.price)}</strike>&nbsp;</span>;
    }
    return null;
  }

  render() {
    return (
      <span>
        {this.originalPrice}
        {this.price}
      </span>
    );
  }
}

PriceWithChange.propTypes = {
  price: PropTypes.object.isRequired,
  discountedPrice: PropTypes.object,
};

module.exports = PriceWithChange;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/price_with_change.jsx